import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let ListPage = class ListPage extends Vue {
    pageChange(val) {
        this.$emit("change", val);
    }
    pageSizeChange(val) {
        this.$emit("size-change", val);
    }
};
__decorate([
    Prop({ default: 0 })
], ListPage.prototype, "total", void 0);
__decorate([
    Prop({ default: 1 })
], ListPage.prototype, "index", void 0);
__decorate([
    Prop({ default: 10 })
], ListPage.prototype, "size", void 0);
__decorate([
    Prop({ default: true })
], ListPage.prototype, "showElevator", void 0);
__decorate([
    Prop({ default: true })
], ListPage.prototype, "showSizer", void 0);
__decorate([
    Prop({ default: "bottom" })
], ListPage.prototype, "placement", void 0);
ListPage = __decorate([
    Component({})
], ListPage);
export default ListPage;
